<div class="page-content">
    <div class="page-header">
        <h1>Tableau de bord</h1>
        <div class="page-description">Gestion des droits d'accès aux compteurs GRDF</div>
    </div>

    <div class="page-body">
        <div class="cards-container">
            <div class="row g-4">
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        title="Compteurs"
                        [isLoading]="isLoading"
                        [body]="{ value: meterCounter }"
                        class="h-100"></kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        title="Dont actifs"
                        [isLoading]="isLoading"
                        [body]="{ value: meterActiveCounter }"
                        class="h-100"></kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        title="Dont en attente de validation"
                        [isLoading]="isLoading"
                        [body]="{ value: meterPendingCounter }"
                        class="h-100"></kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        title="Dont supprimés"
                        [isLoading]="isLoading"
                        [body]="{ value: meterDisabledCounter }"
                        class="h-100"></kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        title="Dont dysfonctionnels"
                        [isLoading]="isLoading"
                        [body]="{ value: meterErrorCounter }"
                        class="h-100"></kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        title="Dont révoqués"
                        [isLoading]="isLoading"
                        [body]="{ value: meterRevokedCounter }"
                        class="h-100"></kpi-card>
                </div>
            </div>

            <br />

            <h1>Droits d'accès actifs</h1>
            <div class="row">
                <table-card
                    *ngIf="meterActiveCounter > 0"
                    [isLoading]="isLoading"
                    (onDropdownMenuClick)="onDropdownMenuClick($event.object, $event.event)"
                    [dataSource]="meterActiveDataSource"
                    [displayedColumns]="meterActiveDisplayedColumns"
                    (onRowClick)="goToDetail($event.toString())"
                    [areActionsInElements]="true">
                </table-card>
                <span class="emptyTable" *ngIf="meterActiveCounter === 0">
                    Vous n'avez aucun droit d'accès actif</span
                >
            </div>
            <ed-button [icon]="'icon-plus'" (click)="openModalCreateAccessRight()">
                Déclarer un nouvel accès
            </ed-button>

            <br />

            <h1>Droits d'accès en attente de validation du représentant</h1>
            <div class="row">
                <table-card
                    *ngIf="meterPendingCounter > 0"
                    [isLoading]="isLoading"
                    (onDropdownMenuClick)="onDropdownMenuClick($event.object, $event.event)"
                    [dataSource]="meterPendingDataSource"
                    [displayedColumns]="meterActiveDisplayedColumns"
                    [areActionsInElements]="true">
                </table-card>
                <span class="emptyTable" *ngIf="meterPendingCounter === 0">
                    Vous n'avez aucun droit d'accès en attente de validation</span
                >
            </div>

            <br />

            <h1 *ngIf="meterErrorCounter > 0">Compteurs dysfonctionnels</h1>
            <div class="row" *ngIf="meterErrorCounter > 0">
                <table-card
                    [isLoading]="isLoading"
                    (onDropdownMenuClick)="onDropdownMenuClick($event.object, $event.event)"
                    [dataSource]="meterErrorDataSource"
                    [displayedColumns]="meterErrorDisplayedColumns"
                    [areActionsInElements]="true">
                </table-card>
            </div>

            <br />
            <h1>Droits d'accès désactivés</h1>
            <div class="row" *ngIf="meterDisabledCounter > 0">
                <table-card
                    [isLoading]="isLoading"
                    (onDropdownMenuClick)="onDropdownMenuClick($event.object, $event.event)"
                    [dataSource]="meterDisabledDataSource"
                    [displayedColumns]="meterDisabledDisplayedColumns"
                    [areActionsInElements]="true">
                </table-card>
            </div>
            <span class="emptyTable" *ngIf="meterDisabledCounter === 0">
                Vous n'avez aucun droit d'accès désactivé</span
            >
            <br />

            <h1>Droits d'accès expirés</h1>
            <div class="row" *ngIf="meterExpiredCounter > 0">
                <table-card
                    [isLoading]="isLoading"
                    [dataSource]="meterExpiredDataSource"
                    [displayedColumns]="meterActiveDisplayedColumns">
                </table-card>
            </div>
            <span class="emptyTable" *ngIf="meterExpiredCounter === 0">
                Vous n'avez aucun droit d'accès expiré</span
            >
            <br />

            <h1>Droits d'accès révoqués par le titulaire</h1>
            <div class="row" *ngIf="meterRevokedCounter > 0">
                <table-card
                    [isLoading]="isLoading"
                    [dataSource]="meterRevokedDataSource"
                    [displayedColumns]="meterDisabledDisplayedColumns">
                </table-card>
            </div>
            <span class="emptyTable" *ngIf="meterRevokedCounter === 0">
                Vous n'avez aucun droit d'accès révoqué</span
            >

            <br />

            <h1 *ngIf="loggedUser?.isAdmin">Tous les droits d'accès GRDF (Admin uniquement)</h1>
            <div
                class="row"
                *ngIf="loggedUser?.isAdmin && grdfRemoteAccessRightsDatasource.data.length > 0">
                <table-card
                    [isLoading]="isLoading"
                    [dataSource]="grdfRemoteAccessRightsDatasource"
                    [displayedColumns]="grdfRemoteAccessRightsColumns"
                    (onDropdownMenuClick)="onDropdownMenuClickRemote($event.object, $event.event)"
                    [areActionsInElements]="true">
                </table-card>
            </div>
            <span
                class="emptyTable"
                *ngIf="loggedUser?.isAdmin && grdfRemoteAccessRightsDatasource.data.length === 0">
                Nous n'avez aucun PCE déclaré sur votre espace GRDF</span
            >
        </div>
    </div>
</div>
